var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { AUTOMOTIVE_THEME_PRESETS, UI_THEME_PRESETS, formatInvalidValue, formatExpectedValues, } from '../sceneCatalog';
import { valueKind, looksLikeColorOrImage } from './colorHelpers';
import { issue, toErrorLines } from './issues';
/**
 * Validate a theme pack object (`preset`, brand tokens, series, …).
 * Suggests known UI presets and automotive themes when values are wrong.
 */
export function validateThemePack(pack, options) {
    var e_1, _a;
    if (options === void 0) { options = {}; }
    var strictPreset = options.strictPreset !== false;
    var issues = [];
    if (pack === null || typeof pack !== 'object' || Array.isArray(pack)) {
        issues.push(issue('theme', "expected a theme pack object, got ".concat(valueKind(pack)), 'theme_type'));
        return { valid: false, errors: toErrorLines(issues), issues: issues };
    }
    var obj = pack;
    if (obj.preset !== undefined && obj.preset !== null) {
        if (typeof obj.preset !== 'string') {
            issues.push(issue('theme.preset', "must be a string (".concat(formatExpectedValues(UI_THEME_PRESETS), "), got ").concat(valueKind(obj.preset)), 'preset_type', __spreadArray([], __read(UI_THEME_PRESETS), false)));
        }
        else if (strictPreset &&
            !UI_THEME_PRESETS.includes(obj.preset) &&
            !looksLikeColorOrImage(obj.preset)) {
            issues.push(issue('theme.preset', formatInvalidValue(obj.preset, UI_THEME_PRESETS) + ' — or a CSS color / image path', 'preset_enum', __spreadArray([], __read(UI_THEME_PRESETS), false)));
        }
    }
    if (obj.automotive !== undefined && obj.automotive !== null) {
        if (typeof obj.automotive !== 'string') {
            issues.push(issue('theme.automotive', "must be a string (".concat(formatExpectedValues(AUTOMOTIVE_THEME_PRESETS), "), got ").concat(valueKind(obj.automotive)), 'automotive_type', __spreadArray([], __read(AUTOMOTIVE_THEME_PRESETS), false)));
        }
        else if (!AUTOMOTIVE_THEME_PRESETS.includes(obj.automotive)) {
            issues.push(issue('theme.automotive', formatInvalidValue(obj.automotive, AUTOMOTIVE_THEME_PRESETS), 'automotive_enum', __spreadArray([], __read(AUTOMOTIVE_THEME_PRESETS), false)));
        }
    }
    if (obj.series !== undefined && obj.series !== null && !Array.isArray(obj.series)) {
        issues.push(issue('theme.series', "must be an array of color strings when present, got ".concat(valueKind(obj.series)), 'series_type'));
    }
    try {
        for (var _b = __values(['dashboard', 'diagram']), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            if (obj[key] !== undefined && obj[key] !== null) {
                if (typeof obj[key] !== 'object' || Array.isArray(obj[key])) {
                    issues.push(issue("theme.".concat(key), "must be an object when present, got ".concat(valueKind(obj[key])), "".concat(key, "_type")));
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return { valid: issues.length === 0, errors: toErrorLines(issues), issues: issues };
}
